import React from 'react';
export function CredibilityBlock() {
  const badges = [{
    label: 'FDA-approved',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10" data-id="element-62">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-63" />
          <path d="M9 12l2 2 4-4" data-id="element-64" />
        </svg>
  }, {
    label: 'Compounded',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10" data-id="element-65">
          <path d="M4 10h16l-2 10H6L4 10z" data-id="element-66" />
          <path d="M14 10L10 2" data-id="element-67" />
          <path d="M4 10c0-1.5 3.5-3 8-3s8 1.5 8 3" data-id="element-68" />
        </svg>
  }, {
    label: 'Plant-derived',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-10 h-10" data-id="element-69">
          <path d="M12 22v-8" data-id="element-70" />
          <path d="M12 14C8 14 5 11 5 7c4 0 7 3 7 7z" data-id="element-71" />
          <path d="M12 14c4 0 7-3 7-7-4 0-7 3-7 7z" data-id="element-72" />
        </svg>
  }];
  const treatments = [{
    label: 'Oral',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-14 h-14" data-id="element-73">
          <rect x="4" y="10" width="16" height="8" rx="4" transform="rotate(-45 12 12)" data-id="element-74" />
          <path d="M9 15l6-6" data-id="element-75" />
        </svg>
  }, {
    label: 'Body',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-14 h-14" data-id="element-76">
          <path d="M7 5h10v3H7z" data-id="element-77" />
          <path d="M8 8v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8" data-id="element-78" />
          <path d="M10 2h4v3h-4z" data-id="element-79" />
        </svg>
  }, {
    label: 'Vaginal',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-14 h-14" data-id="element-80">
          <rect x="10" y="4" width="4" height="16" rx="2" data-id="element-81" />
          <path d="M10 8h4" data-id="element-82" />
          <path d="M10 16h4" data-id="element-83" />
        </svg>
  }, {
    label: 'Patch',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-14 h-14" data-id="element-84">
          <rect x="6" y="6" width="12" height="12" rx="2" data-id="element-85" />
          <path d="M10 10h4v4h-4z" data-id="element-86" />
        </svg>
  }];
  return <section className="bg-orla-bone py-16 md:py-32" data-id="element-87">
      <div className="max-w-[960px] mx-auto px-6" data-id="element-88">
        <h2 className="font-display font-black text-[32px] md:text-[48px] text-orla-ink tracking-tight leading-[1.1] text-center" data-id="element-89">
          The #1 physician-recommended approach to perimenopause.
        </h2>
        <p className="mt-4 font-body text-[17px] text-orla-muted max-w-[640px] mx-auto text-center" data-id="element-90">
          Bioidentical HRT is clinically proven to ease perimenopause symptoms
          safely and effectively.
        </p>

        {/* Badges */}
        <div className="mt-16 flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12" data-id="element-91">
          {badges.map((badge, idx) => <div key={idx} className="flex flex-col items-center" data-id="element-92">
              <div className="w-[80px] h-[80px] rounded-full bg-[rgba(155,71,34,0.08)] flex items-center justify-center text-orla-sienna" data-id="element-93">
                {badge.icon}
              </div>
              <span className="mt-4 font-body font-semibold text-[15px] text-orla-ink text-center" data-id="element-94">
                {badge.label}
              </span>
            </div>)}
        </div>

        {/* Divider */}
        <div className="mt-16 h-px bg-orla-border max-w-[480px] mx-auto" data-id="element-95" />

        {/* Ways to Treat */}
        <div className="mt-12" data-id="element-96">
          <h3 className="font-body font-semibold text-[13px] text-orla-saffron uppercase tracking-[0.06em] text-center" data-id="element-97">
            WAYS TO TREAT
          </h3>
          <div className="mt-6 grid grid-cols-2 md:flex md:justify-center gap-6 md:gap-12" data-id="element-98">
            {treatments.map((treatment, idx) => <div key={idx} className="flex flex-col items-center" data-id="element-99">
                <div className="text-orla-sienna" data-id="element-100">{treatment.icon}</div>
                <span className="mt-3 font-body font-medium text-[14px] text-orla-ink text-center" data-id="element-101">
                  {treatment.label}
                </span>
              </div>)}
          </div>
        </div>

        {/* Link */}
        <a href="#" className="mt-12 block font-body font-semibold text-[15px] text-orla-saffron text-center hover:underline" data-id="element-102">
          Explore all treatments &rarr;
        </a>
      </div>
    </section>;
}